"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSignOutRequestForPagesRouter = void 0;
const utils_1 = require("../utils");
const handleSignOutRequestForPagesRouter = ({ response, oAuthConfig, userPoolClientId, origin, setCookieOptions }) => {
    const urlSearchParams = new URLSearchParams({
        client_id: userPoolClientId,
        logout_uri: (0, utils_1.resolveRedirectSignOutUrl)(origin, oAuthConfig),
    });
    (0, utils_1.appendSetCookieHeadersToNextApiResponse)(response, (0, utils_1.createSignOutFlowProofCookies)(), (0, utils_1.createAuthFlowProofCookiesSetOptions)(setCookieOptions, origin));
    response.redirect(302, (0, utils_1.createLogoutEndpoint)(oAuthConfig.domain, urlSearchParams));
};
exports.handleSignOutRequestForPagesRouter = handleSignOutRequestForPagesRouter;
